import { action, makeObservable, observable } from 'mobx';
import { setLocale } from '@/i18n';
import { resolveLocale } from '@/constants/locale';
const storage = localStorage;

export class Locale {
  @observable lang = resolveLocale(storage.getItem('locale'));

  constructor() {
    makeObservable(this);
  }

  @action
  setLang = (sign: string) => {
    const resolved = resolveLocale(sign);
    setLocale(resolved);
    this.lang = resolved;
  };

  @action
  getLang = () => {
    return this.lang;
  };
}

export default new Locale();
